module.exports = __webpack_public_path__ + "img/good.be5030ca.webp";